import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import mail from '../../assets/images/mail_icon.png'
import ticket from '../../assets/images/ticket.png'
import { supabase } from '../../lib/supabase'
import { siteCopy } from '../../content/siteCopy'

const Contactus = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [honeypot, setHoneypot] = useState('')
  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState(null)
  const supportEmail = siteCopy.footer.supportEmail
  const { contact } = siteCopy

  const openMailtoFallback = () => {
    const subject = encodeURIComponent(`${siteCopy.brand} support from ${name.trim() || 'user'}`)
    const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}\n`)
    window.location.href = `mailto:${supportEmail}?subject=${subject}&body=${body}`
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (honeypot) return
    const trimmedName = name.trim()
    const trimmedEmail = (email || '').trim().toLowerCase()
    const trimmedMessage = message.trim()
    if (!trimmedName || !trimmedEmail || !trimmedMessage) return

    if (!supabase) {
      setStatus('error')
      openMailtoFallback()
      return
    }

    setLoading(true)
    setStatus(null)
    const { error } = await supabase.from('contact_submissions').insert({
      name: trimmedName.slice(0, 100),
      email: trimmedEmail.slice(0, 255),
      message: trimmedMessage.slice(0, 2000),
      source: 'website',
      page_path: '/contact',
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
    })
    setLoading(false)

    if (error) {
      setStatus('error')
      openMailtoFallback()
      return
    }

    setStatus('success')
    setName('')
    setEmail('')
    setMessage('')
  }

  return (
    <section className="row_am contact_page_section">
      <div className="container">
        <div className="contact_inner">
          <div className="row">
            <div className="col-lg-6">
              <div className="contact_info">
                <div className="section_title">
                  <h3>{contact.title}</h3>
                  <p>{contact.intro}</p>
                </div>
                <ul className="contact_info_list">
                  <li>
                    <div className="img">
                      <img src={mail} alt="" />
                    </div>
                    <div className="text">
                      <span>Email</span>
                      <Link to={`mailto:${supportEmail}`}>{supportEmail}</Link>
                    </div>
                  </li>
                </ul>
                <div className="ticket_box">
                  <div className="icon">
                    <img src={ticket} alt="" />
                  </div>
                  <div className="section_title">
                    <h4>Before you write</h4>
                    <p>
                      Include your app version and device (iOS/Android) if your question is about
                      the mobile app. For account-sensitive issues, use the email address you
                      registered with.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="contact_form">
                <div className="section_title">
                  <h3>Contact us</h3>
                  <p>Send a message to our support team.</p>
                </div>
                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="website"
                    tabIndex={-1}
                    autoComplete="off"
                    value={honeypot}
                    onChange={(e) => setHoneypot(e.target.value)}
                    style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, opacity: 0 }}
                    aria-hidden="true"
                  />
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Your name"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      placeholder="Your email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      placeholder="Your message"
                      rows={6}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      required
                    />
                  </div>
                  <p className="note">
                    We use your details only to respond to this enquiry, in line with our{' '}
                    <Link to="/privacy-policy">Privacy Policy</Link>.
                  </p>
                  {status === 'success' && <p className="note">Thanks. We will get back to you soon.</p>}
                  {status === 'error' && (
                    <p className="note">
                      We could not save your message. Please email {supportEmail}.
                    </p>
                  )}
                  <div className="form-group mb-0">
                    <button type="submit" className="btn puprple_btn" disabled={loading}>
                      {loading ? 'Sending…' : 'Send message'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contactus
